import { useSelector } from "react-redux";

import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { ExportVariantsDropdownItem } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { selectExcelQuota } from "app/pages/sales-intelligence/sub-modules/common/store/selectors";
import { isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

type WebsitesExcelExportItemContainerProps = {
    onClick(): void;
};

const WebsitesExcelExportItemContainer = (props: WebsitesExcelExportItemContainerProps) => {
    const isExportAllowed = salesSettingsHelper.isExcelAllowed();
    const excelQuota = useSelector(selectExcelQuota);
    const isTrialUserWithoutClaim = !isExportAllowed && isTrial(swSettings);
    const tooltipKey = isTrialUserWithoutClaim
        ? "si.websites-export.disabled.text"
        : "si.websites-export.quota-reached.text";

    return (
        <ExportVariantsDropdownItem
            variant="excel"
            iconName="excel"
            isDisabled={!isExportAllowed || excelQuota.remaining === 0}
            text={translate("si.multi_selector.export_options.excel.btn.label")}
            tooltipDisabledContent={<span>{translate(tooltipKey)}</span>}
            onClick={props.onClick}
        />
    );
};

export default WebsitesExcelExportItemContainer;
